<div id="dialog-container">
  <h1 mat-dialog-title>{{ modalTitle | translate }}</h1>

  <mat-divider></mat-divider>

  @if (missingRequiredFields$ | async; as missingRequiredFields) {
    @if (missingRequiredFields.length > 0) {
      <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
          <span>{{ 'MESSAGE.INSUFFICIENT_FIELDS_PERMISSIONS' | translate }}</span>
        <ul>
          @for (field of missingRequiredFields; track field.code) {
            <li>{{ field.label }}</li>
          }
        </ul>
      </mat-dialog-content>
      <mat-dialog-actions class="center">
        <button mat-raised-button matDialogClose="cancel" color="accent" id="dialog-cancel-button">
          {{ 'BUTTON.CANCEL' | translate }}
        </button>
      </mat-dialog-actions>
    } @else {
      <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
        <div class="form-container">

          @if (accessManager.hasFieldWriteAccess('assetId', EntityTypeEnum.WORK) && accessManager.hasFieldWriteAccess('spaceIds', EntityTypeEnum.WORK)) {
            <form [formGroup]="workForm">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'LABEL.ASSET' | translate }}</mat-label>
                <mat-select-asset-autocomplete formControlName="asset" [allowedEntityIds]="allowedEntityIds"
                                               [required]="requireAsset">
                </mat-select-asset-autocomplete>
              </mat-form-field>

              @if (assetTypeAllowsSpaceModule) {
                <div class="space-form-field">
                  <div class="ag-grid-container">
                    <ag-grid-angular
                      (gridReady)="onGridReady($event)"
                      [gridOptions]="gridOptions"
                      [rowData]="spaces | async"
                      class="ag-theme-material"
                      id="work_spaces_grid">
                    </ag-grid-angular>
                  </div>
                  @if (workForm.controls.spaces.touched && workForm.controls.spaces.hasError('required')) {
                    <mat-error>
                      {{ 'ERROR.FIELD_REQUIRED'| translate }}
                    </mat-error>
                  }
                  @if (workForm.controls.spaces.hasError('incoherentSpaces')) {
                    <mat-error>
                      {{ 'ERROR.SPACES_INCOHERENT' | translate }}
                    </mat-error>
                  }
                </div>
              }
            </form>
          }

          <div class="button-container fx-layout-row fx-justify-end fx-align-center">
            <button mat-stroked-button id="duplicate-work-cancel-button" matDialogClose="cancel">
              {{ 'BUTTON.CANCEL' | translate }}
            </button>
            <button mat-raised-button id="duplicate-work-add-button" [disabled]="workForm.invalid" color="accent"
                    matDialogClose="yes">
              {{ 'BUTTON.ADD' | translate }}
            </button>
          </div>
        </div>
      </mat-dialog-content>
    }
  } @else {
    <spinner></spinner>
  }
</div>
